<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <b-card class="m-3 mt-n10">
      <b-form @submit="onSubmit">
        <b-form-group :label="$t('loinc.form.fields.loinc.label')" label-for="input-loinc">
          <b-form-input id="input-loinc" v-model="exam.loinc" type="text"/>
        </b-form-group>
        <b-form-group :label="$t('loinc.form.fields.nome_longo.label')" label-for="input-long_common_name">
          <b-form-input id="input-long_common_name" v-model="exam.long_common_name" type="text"/>
        </b-form-group>
        <b-form-group :label="$t('loinc.form.fields.nome_curto.label')" label-for="input-short_name">
          <b-form-input id="input-short_name" v-model="exam.short_name" type="text"/>
        </b-form-group>
        <b-form-group :label="$t('loinc.form.fields.nome_exibicao.label')" label-for="input-display_name">
          <b-form-input id="input-display_name" v-model="exam.display_name" type="text"/>
        </b-form-group>

        <b-form-group :label="$t('loinc.form.fields.status.label')" label-for="input-status">
          <SelectComponent
              id="input-status"
              :model="exam.status"
              :options="status"
              @input="evt => setLoinc('status', evt)"
          />
        </b-form-group>
        <b-form-group :label="$t('loinc.form.fields.ordem_obs.label')" label-for="input-order_observation">
          <SelectComponent
              id="input-order_observation"
              :model="exam.order_observation"
              :options="order_observations"
              @input="evt => setLoinc('order_observation', evt)"
          />
        </b-form-group>

        <div class="row">
          <div class="col">
            <b-form-group :label="$t('loinc.form.fields.componente.label')" label-for="input-component">
              <b-form-input id="input-component" v-model="exam.component" type="text"/>
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group :label="$t('loinc.form.fields.propriedade.label')" label-for="input-property">
              <b-form-input id="input-property" v-model="exam.property" type="text"/>
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group :label="$t('loinc.form.fields.tempo.label')" label-for="input-time">
              <b-form-input id="input-time" v-model="exam.time" type="text"/>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b-form-group :label="$t('loinc.form.fields.sistema.label')" label-for="input-system">
              <b-form-input id="input-system" v-model="exam.system" type="text"/>
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group :label="$t('loinc.form.fields.escala.label')" label-for="input-scale">
              <b-form-input id="input-scale" v-model="exam.scale" type="text"/>
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group :label="$t('loinc.form.fields.metodo.label')" label-for="input-method">
              <b-form-input id="input-method" v-model="exam.method" type="text"/>
            </b-form-group>
          </div>
        </div>

        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('loinc.form.fields.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import SelectComponent from "@/components/SelectComponent";
import LoincRepository from '@/repositories/loinc/LoincRepository'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    SelectComponent,
    LayoutGradient
  },
  computed: {
    ...mapGetters({
      exam: 'loinc/current',
      isLoading: 'loinc/isLoading',
      synonyms: 'loinc/getSynonyms',
      langs: 'loinc/getLangs',
      store_status: 'loinc/getStatusOptions',
      store_order_observations: 'loinc/getOrderObsOptions',
    }),
    status() {
      if (this.store_status && Array.isArray(this.store_status)) {
        return this.store_status.map(status => {
          return {
            label: status.name,
            value: status.id
          }
        })
      }
      return [];
    },
    order_observations() {
      if (this.store_order_observations && Array.isArray(this.store_order_observations)) {
        return this.store_order_observations.map(status => {
          return {
            label: status.name,
            value: status.id
          }
        })
      }
      return [];
    },
    pageTitle() {
      if (this.exam_id) return this.$t('loinc.form.titulo_pagina.editar')
      return this.$t('loinc.form.titulo_pagina.criar')
    }
  },
  data() {
    return {
      exam_id: null
    }
  },
  methods: {
    ...mapActions([
      'loinc/listOne',
      'loinc/listSynonyms',
      'loinc/listLangs',
      'loinc/listOptions',
    ]),
    setLoinc(key, value) {
      this.$store.commit('loinc/setCurrent', {...this.exam, [key]: value})
    },
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      LoincRepository.post({
        ...this.exam,
        status: this.exam.status && this.exam.status.value ? this.exam.status.value : null,
        order_observation: this.exam.order_observation && this.exam.order_observation.value ? this.exam.order_observation.value : null
      }).then(() => {
        this.$snotify.success(this.$t('loinc.form.create.success'))
        this.$router.push({name: 'loinc.index'})
      }).catch(() => {
        this.$snotify.error(this.$t('loinc.form.create.error'))
      })
    },
    update() {
      LoincRepository.put({
        ...this.exam,
        id: this.exam_id,
        status: this.exam.status && this.exam.status.value ? this.exam.status.value : null,
        order_observation: this.exam.order_observation && this.exam.order_observation.value ? this.exam.order_observation.value : null
      }).then(() => {
        this.$snotify.success(this.$t('loinc.form.update.success'))
        this.$router.push({name: 'loinc.index'})
      }).catch(() => {
        this.$snotify.error(this.$t('loinc.form.update.error'))
      })
    }
  },
  async mounted() {
    this.$store.commit('loinc/setCurrent', {})
    if (this.$route.params.id) {
      this.exam_id = this.$route.params.id
      await this['loinc/listOne'](this.$route.params.id)
      await this['loinc/listSynonyms'](this.$route.params.id)
      await this['loinc/listLangs'](this.$route.params.id)
      if (this.exam.status && this.exam.status.id) {
        this.setLoinc('status', {
          label: this.exam.status.name,
          value: this.exam.status.id
        })
      }
      if (this.exam.order_observation && this.exam.order_observation.id) {
        this.setLoinc('order_observation', {
          label: this.exam.order_observation.name,
          value: this.exam.order_observation.id
        })
      }
    }
    await this['loinc/listOptions']()
  }
}
</script>

<style lang="scss" scoped>
</style>
